export default "__VITE_ASSET__325f8375__"